import {
    SET_BONUS,
    SET_BONUS_DELETE
} from "@/views/bonus/store/types/types.js";

const mutations = {
    [SET_BONUS]: (state, payload) => state.bonus = payload,
    [SET_BONUS_DELETE]: (state, payload) => state.bonusDelete = payload,
 }

export default mutations;